import "./ProjectsCaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Projects from "./sections/Projects";
import CaseHighlight from "./sections/CaseHighlight";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsCaseStudiesPage() {
  return <div>
      <Header />
      <Projects />
      <CaseHighlight />
      <Quote />
      <Footer />
    </div>;
}